import log from 'salvo-lite/log'

class ReadMore {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const container = this._elem
        const btns = this._elem.querySelectorAll('.read-more__btn')

        if (btns.length > 0) {
            btns.forEach(btn => {
                btn.addEventListener('click', () => {
                    container.classList.toggle('open')
                })
            })
        }
    }
}

export default ReadMore



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ReadMore.js